// Gesamtfortschritt einer Probe über alle ihre Ketten (Tim 17.10.2026:
// „wenn alles läuft oder mehr als eine, den Gesamtfortschritt anzeigen und
// nicht den von einer einzelnen Probe").
//
// Nach Ketten gezählt stand am 17.10. um 21:12 „62 %" da -- vier Minuten
// vor dem Ende eines Laufs von 47 Minuten: die großen Ketten kommen
// zuerst, die vielen kleinen am Schluss. Darum zählt jede Kette mit ihrer
// Dauer beim letzten Mal (Erfahrung), eine ohne Erfahrung mit dem Mittel
// der bekannten, ganz ohne Erfahrung jede gleich. Ohne Stores und ohne
// Texte: getestet in probe-gesamt.test.mjs.

import type { ProbeErgebnis, ProbeKette, ProbeLauf } from "../backup-probe.svelte";

const FERTIG = new Set(["ok", "fehler", "abgebrochen"]);

export interface Gesamt {
  /** 0..1 */
  anteil: number;
  /** Ketten mit Urteil */
  fertig: number;
  /** geprüfte Ketten des Laufs */
  ketten: number;
}

/** Je Kette die Dauer (s) ihrer letzten fertigen Probe. */
export function erfahrungAus(ketten: readonly ProbeKette[]): Record<string, number> {
  const aus: Record<string, number> = {};
  for (const k of ketten) {
    let beste: { ende: string; dauer: number } | undefined;
    for (const v of k.verlauf ?? []) {
      if ((v.zustand === "ok" || v.zustand === "fehler") && (v.dauer_s ?? 0) > 0 && (!beste || (v.ende ?? "") > beste.ende)) {
        beste = { ende: v.ende ?? "", dauer: v.dauer_s! };
      }
    }
    const l = k.letzter;
    if (!beste && l && (l.zustand === "ok" || l.zustand === "fehler") && (l.dauer_s ?? 0) > 0) beste = { ende: "", dauer: l.dauer_s! };
    if (beste) aus[k.plan.kette] = beste.dauer;
  }
  return aus;
}

/** Wie weit eine Kette ist: ihre Schritte zu gleichen Teilen. */
function kettenAnteil(e: ProbeErgebnis): number {
  if (!e.halte?.length) return 0;
  const done = e.halte.filter((s) => s.zustand === "ok" || s.zustand === "entfaellt").length;
  const lfd = e.halte.find((s) => s.zustand === "laeuft");
  return (done + (lfd?.anteil ?? 0)) / e.halte.length;
}

export function gesamtFortschritt(lauf: ProbeLauf, erfahrung: Record<string, number> = {}): Gesamt | undefined {
  const geprueft = lauf.ketten.filter((e) => e.pruefbar);
  if (!geprueft.length) return undefined;
  const bekannt = geprueft.map((e) => erfahrung[e.kette]).filter((d) => d > 0);
  const mittel = bekannt.length ? bekannt.reduce((a, b) => a + b, 0) / bekannt.length : 1;
  let summe = 0;
  let erledigt = 0;
  let fertig = 0;
  for (const e of geprueft) {
    const g = erfahrung[e.kette] > 0 ? erfahrung[e.kette] : mittel;
    summe += g;
    if (FERTIG.has(e.zustand)) {
      erledigt += g;
      fertig++;
    } else if (e.kette === lauf.aktiv) {
      erledigt += g * kettenAnteil(e);
    }
  }
  return { anteil: erledigt / summe, fertig, ketten: geprueft.length };
}
